import { Howl, Howler } from 'howler';

export class AudioController {
  enabled: boolean;
  private sounds = new Map<string, Howl>();

  constructor() {
    this.enabled = localStorage.getItem('stanwars.audio') === 'on';
    Howler.mute(!this.enabled);
  }

  enable(): void {
    this.enabled = true;
    Howler.mute(false);
    localStorage.setItem('stanwars.audio', 'on');
    if (typeof Howler.ctx !== 'undefined' && Howler.ctx.state === 'suspended') {
      void Howler.ctx.resume();
    }
  }

  disable(): void {
    this.enabled = false;
    Howler.mute(true);
    localStorage.setItem('stanwars.audio', 'off');
  }

  load(id: string, src: string): void {
    if (this.sounds.has(id)) return;
    this.sounds.set(id, new Howl({ src: [src], preload: true }));
  }

  play(id: string, opts?: { loop?: boolean; volume?: number }): void {
    if (!this.enabled) return;
    const h = this.sounds.get(id);
    if (!h) return;
    if (opts?.loop !== undefined) h.loop(opts.loop);
    if (opts?.volume !== undefined) h.volume(opts.volume);
    h.play();
  }
}
